"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHu_PG_queryHelper_enqueueTask = void 0;
const SHu_PG_queryHelper_enqueueTask = ({ creator, event, payload, queueTable }) => {
    const query = `INSERT INTO ${queueTable || "queue"} (creator, event, payload) VALUES ($1, $2, $3) RETURNING qid`;
    return [query, [creator, event, JSON.stringify(payload)]];
};
exports.SHu_PG_queryHelper_enqueueTask = SHu_PG_queryHelper_enqueueTask;
